'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _TitleAndText2 = require('./TitleAndText');

var _TitleAndText3 = _interopRequireDefault(_TitleAndText2);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 */
var MethodURL = function (_TitleAndText) {
	_inherits(MethodURL, _TitleAndText);

	function MethodURL(props) {
		_classCallCheck(this, MethodURL);

		var _this = _possibleConstructorReturn(this, (MethodURL.__proto__ || Object.getPrototypeOf(MethodURL)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		return _this;
	}

	_createClass(MethodURL, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			var host = this.props.host || (0, _util.getBrowserUrlLocation)();
			var url = '' + host + (this.props.prefix || '') + this.props.path;
			if (this.props.expressPaths) {
				url = (0, _util.swaggerPathToExpress)(url);
			}

			this.setState({
				heading: this.intl.formatMsg('HTTP request'),
				text: _react2.default.createElement(
					'span',
					null,
					_react2.default.createElement(
						'b',
						null,
						this.props.verb.toUpperCase()
					),
					' ',
					url
				)
			});
		}
	}]);

	return MethodURL;
}(_TitleAndText3.default);

MethodURL.propTypes = {

	/**
  * Include a prefix when rendering the method summary.  By default, there is no prefix.
  * If the method is "/foo", it will display "/foo".  If you want to include the basePath,
  * you must explicitly set it as the prefix. If speficied it must start with a leading slash.
  */
	prefix: function prefix(props, propName, componentName) {
		if (props[propName] === undefined || props[propName] === null) {
			return;
		}
		if (typeof props[propName] !== 'string') {
			return new Error('Invalid prop prefix supplied to' + (' `' + componentName + '`. prefix must be a string. Validation failed.'));
		} else if (props[propName][0] !== '/') {
			return new Error('Invalid prop prefix supplied to' + (' `' + componentName + '`. prefix must have a leading /. Validation failed.'));
		}
	},


	/**
  * Swagger 2.0 method
  */
	method: _propTypes2.default.object.isRequired,

	/**
  * HTTP verb
  */
	verb: _propTypes2.default.string.isRequired,

	/**
  * HTTP path
  */
	path: _propTypes2.default.string.isRequired,

	/**
  * Render Express style paths instead of Swagger style.
  */
	expressPaths: _propTypes2.default.bool
};

var _default = (0, _reactIntl.injectIntl)(MethodURL);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(MethodURL, 'MethodURL', 'src/components/SwaggerUI/MethodURL.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/SwaggerUI/MethodURL.jsx');
}();

;